import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalStateService } from '../../../core/services/modal-state.service';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'hntr-toast-host',
  imports: [NgIcon, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'toast-wrap', 'aria-live': 'polite', role: 'status' },
  template: `
    @for (toast of toastService.toasts(); track toast.id) {
      @if (toast.type === 'mesh' && toast.mesh; as m) {
        <div class="toast show toast-mesh">
          <ng-icon name="tablerBellRinging" class="mesh-bell" size="16" aria-hidden="true" />
          <div class="mesh-text">
            <span class="mesh-title">{{ 'alerts.meshToast.title' | translate }}</span>
            <span class="mesh-sub">{{ m.vrm }} &mdash; {{ m.location }}</span>
            @if (m.theftId) {
              <button type="button" class="mesh-action" (click)="openTheft(m.theftId, toast.id)">
                {{ 'alerts.meshToast.openTheft' | translate }}
              </button>
            } @else {
              <span class="mesh-no-record">{{ 'alerts.meshToast.noRecord' | translate }}</span>
            }
          </div>
          <!-- Feedback #18: the 8s mesh toast sits over the header menu — let operators dismiss it. -->
          <button
            type="button"
            class="mesh-close"
            (click)="toastService.dismiss(toast.id)"
            [attr.aria-label]="'common.close' | translate"
          >
            <ng-icon name="tablerX" size="14" />
          </button>
        </div>
      } @else {
        <div class="toast show" [class.toast-ok]="toast.type === 'ok'" [class.toast-err]="toast.type === 'err'">
          {{ toast.message }}
        </div>
      }
    }
  `,
})
export class ToastHost {
  protected readonly toastService = inject(ToastService);
  private readonly modalState = inject(ModalStateService);
  private readonly router = inject(Router);

  openTheft(theftId: string, toastId: number): void {
    this.modalState.requestTheft(theftId);
    this.toastService.dismiss(toastId);
    this.router.navigateByUrl('/dashboard');
  }
}
